<template>
  <div class="container-fluid p-0">
    <Header></Header>
   
    <div class="row pb-4">
      <!-- CONTENT -->
      <div class="col col-sm-12 col-md-9">
        <router-view  class="m-3 p-3"/>
      </div>

      <!-- SIDEBAR -->
      <div class="col col-sm-12 col-md-3">
        <Sidebar></Sidebar>
      </div>
    </div>
    <!-- FOOTER -->
    <Footer></Footer>
  </div>
</template>
<script>
import Sidebar from "@/components/Sidebar";
import Footer from "@/components/Footer";
import Header from "@/components/Header";

export default {
  name: "app",
  components: {
    Sidebar,
    Footer,
    Header
  },
};
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #FFFFFF;
}

ul.marked {list-style: none}
ul.marked > li::before {
  content: "\25CF"; 
  color: orange; 
  font-weight: bold;
  display: inline-block; 
  width: 1em; 
  margin-left: -1.5em; 
  padding-right:1.5em;
  
}
ul.marked > li {
  border-bottom: 1px dotted grey;    
}
</style>
